import { useAppSelector } from 'app/hooks';
import { AxiosError } from 'axios';
import AlertModal from 'components/common/AlertModal';
import FeatureTitleBar from 'components/common/FeatureTitleBar';
import useGlobalModal from 'components/common/GlobalModal/useGlobalModal';
import { selectIsEditMode } from 'features/common/editModeSlice';
import { Menu, MenuClassification } from 'features/MenuList/models/menu';
import { useEffect, useState } from 'react';
import { Modal, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { handleServiceError } from 'utils';
import Filter from './components/Filter';
import TableList from './components/TableList';
import service from './services';

export interface MenuAddModalReturnData {
  genreId?: number;
  subGenreId?: number;
  selectedMenus: Array<{ id: number; name: string; coupon_classification: number }>;
}

export interface MenuAddModalProps {
  isShowModal: boolean;
  genreId?: number;
  subGenreId?: number;
  genreName?: string;
  subgenreName?: string;
  exceptMenuIds?: number[];
  menuType?: number;
  dataDate: Date;
  onReflect?: (returnData: MenuAddModalReturnData) => void;
  onClose: () => void;
}

function MenuAddModal({
  isShowModal,
  genreId,
  subGenreId,
  genreName,
  subgenreName,
  exceptMenuIds = [],
  menuType,
  dataDate,
  onReflect,
  onClose,
}: MenuAddModalProps) {
  const { showGlobalModal } = useGlobalModal();

  // selectors
  const isEditMode = useAppSelector(selectIsEditMode);

  // states
  const [name, setName] = useState('');
  const [menuCode, setMenuCode] = useState('');
  const [menuClassification, setMenuClassification] = useState('');
  const [dataTable, setDataTable] = useState<Menu[]>([]);
  const [menuClassifications, setMenuClassifications] = useState<MenuClassification[]>([]);

  // call API
  async function filterAPI() {
    await service.getMenus(name, menuCode, menuClassification, dataDate, menuType).then((result) => {
      const dataFilter = result.data.filter((menu: Menu) => {
        if (!exceptMenuIds?.includes(menu.id)) {
          return menu;
        } else {
          return null;
        }
      });
      setDataTable(dataFilter);
    });
  }
  // call API menu classification
  async function callAPIMenuClassification() {
    await service.getClassification().then((result) => {
      setMenuClassifications(result.data);
    });
  }

  // first load page
  useEffect(() => {
    async function getDataTable() {
      callAPIMenuClassification();
      filterAPI();
    }
    getDataTable().catch((error) => {
      if (!handleServiceError(showGlobalModal, error as AxiosError)) {
        showGlobalModal(() => (
          <AlertModal title={t('Genre.Validator.error')} message={JSON.stringify(error.response.data.data)} />
        ));
      }
    });
    /* eslint-disable react-hooks/exhaustive-deps */
  }, []);

  // search name
  function callFilter() {
    filterAPI().catch((error) => {
      if (!handleServiceError(showGlobalModal, error as AxiosError)) {
        showGlobalModal(() => (
          <AlertModal title={t('Genre.Validator.error')} message={JSON.stringify(error.response.data.data)} />
        ));
      }
    });
  }

  function handleClose() {
    onClose && onClose();
  }
  const { t } = useTranslation();

  function handleChangeName(event: React.ChangeEvent<HTMLInputElement>) {
    setName(event.target.value);
  }

  function handleBtnOnReflect(selectedMenus: Array<{ id: number; name: string; coupon_classification: number }>) {
    onReflect?.({ genreId, subGenreId, selectedMenus });
  }

  function handleChangeMenuCode(event: React.ChangeEvent<HTMLInputElement>) {
    setMenuCode(event.target.value);
  }

  function handleChangeMenuClassification(event: React.ChangeEvent<HTMLSelectElement>) {
    setMenuClassification(event.target.value);
  }

  return (
    <Modal show={isShowModal} backdrop="static" onHide={handleClose} centered>
      <Modal.Header closeButton className={isEditMode ? 'reedit-mode-wrapper' : ''}>
        <FeatureTitleBar
          title={`${genreName && subgenreName ? `${genreName}｜${subgenreName}｜メニュー追加` : '対象メニュー追加'}`}
        />
      </Modal.Header>
      <Modal.Body className={isEditMode ? 'reedit-mode-wrapper' : ''}>
        <Filter
          menuClassifications={menuClassifications}
          callFilter={callFilter}
          handleChangeName={handleChangeName}
          handleChangeMenuCode={handleChangeMenuCode}
          handleChangeMenuClassification={handleChangeMenuClassification}
          name={name}
          menuCode={menuCode}
          menuClass={menuClassification}
        />
        <Row className="p-3 b-3"></Row>
        {
          <TableList
            dataTable={dataTable}
            setDataTable={setDataTable}
            handleBtnOnReflect={handleBtnOnReflect}
            except_menu_ids={exceptMenuIds}
            menuClassification={menuClassification}
            name={name}
            menuCode={menuCode}
            dataDate={dataDate}
          />
        }
      </Modal.Body>
    </Modal>
  );
}
export default MenuAddModal;
